// Shared with the existing Recipe preparation vocabulary. No master collection.
export const preparationStates = ["Cold", "Chilled", "Frozen", "Room temperature", "Warm", "Hot", "Boiling", "Melted", "Softened", "Chopped", "Finely chopped", "Sliced", "Diced", "Cubed", "Grated", "Minced", "Crushed", "Sifted", "Toasted", "Drained", "Separated"];
// New choices serialize through the existing optional string. Legacy strings
// are never parsed, normalized or replaced unless deliberately edited.
export const encodePreparationChoices = values => preparationStates.filter(value=>values.includes(value)).join(', ');
export const knownPreparationChoices = value => {
  if(value==null||value==='')return [];
  const values=String(value).split(', ');
  return values.every(item=>preparationStates.includes(item))&&encodePreparationChoices(values)===value?values:null;
};
